import React, { useState } from "react";
import useSortableData from "../utils/customHookSortTable";
import LoadingSpinner from "./spinner";
import "../style/drawer.scss";
import PluginTable from "./PluginTable";
import PluginDrawer from "./PluginDrawer";
import BasicButtons from "./buttonChoice";


const FTPComponent = ({ filteredPlugins, handleSort, role, isAdmin, updatePluginPayant, isLoading, error, handlePluginButtonClick, handleSiteButtonClick, handleThemeButtonClick,handleCVEButtonClick }) => {
  // 1) Récupération données si besoin
  // Si vous tenez à ce sortedData, vous pouvez l'utiliser, 
  // mais c'est la liste brute. Mieux vaut laisser PluginTable filtrer/tri.
  const { sortedData } = useSortableData(filteredPlugins);

  // 2) État pour la liste finale filtrée/triée
  const [displayedPlugins, setDisplayedPlugins] = useState([]);

  // 3) État pour la ligne cliquée
  const [selectedRowIndex, setSelectedRowIndex] = useState(null);

  // Au clic sur la ligne n° X
  const handleRowClick = (index) => {
    setSelectedRowIndex(index);
  };
  // Fermer le Drawer
  const handleCloseDrawer = () => {
    setSelectedRowIndex(null);
  };

  if (isLoading) {
    return <LoadingSpinner />;
  }
  if (error) {
    return <div>Erreur lors de la récupération des données FTP</div>;
  }

  return (
    <>
      {/* 
         PluginTable reçoit la liste brute (ex. sortedData)
         + handleRowClick
         + un callback onDisplayedPluginsChange qui nous renvoie la liste finale
      */}

      <BasicButtons
            place="plugin"
            onSiteButtonClick={handleSiteButtonClick}
            onPluginButtonClick={handlePluginButtonClick}
            onThemeButtonClick={handleThemeButtonClick}
            onCVEButtonClick={handleCVEButtonClick}
            role={role}
      />
      <PluginTable
        sortedData={sortedData}
        handleRowClick={handleRowClick}
        role={role}
        isAdmin={isAdmin}
        updatePluginPayant={updatePluginPayant}
        // Quand PluginTable aura fini de filtrer/tri => 
        // il appelle onDisplayedPluginsChange(finalList)
        onDisplayedPluginsChange={setDisplayedPlugins}
      />

      {/* PluginDrawer lit displayedPlugins + selectedRowIndex */}
      <PluginDrawer
        selectedRowIndex={selectedRowIndex}
        displayedPlugins={displayedPlugins}
        handleCloseDrawer={handleCloseDrawer}
        role={role}
      />
    </>
  );
};

export default FTPComponent;
